import { apiPut } from '../api_utils';
import { API_URL } from '../constant';

export const adminLoginAPI = data => apiPut(`${API_URL}/AdminUser/LogIn`, data);
export const sendSMSAPI = data => apiPut(`${API_URL}/AdminUser/SendSMS`, data);
